<template>
  <div class="container experience">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长管理</el-breadcrumb-item>
        <el-breadcrumb-item>学长订单</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学长订单</h2>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query"
               label-width="80px">
        <el-form-item label="订单号"
                      prop="order_no">
          <el-input v-model.trim="query.order_no"
                    placeholder="输入订单编号"
                    @input="searchSetTimeout()"
                    clearable
                    style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="商品名称"
                      prop="goods_name">
          <el-input v-model.trim="query.goods_name"
                    placeholder="输入商品名称"
                    @input="searchSetTimeout()"
                    clearable
                    style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="订单状态"
                      prop="status">
          <el-select v-model="query.status"
                     multiple
                     placeholder="请选择"
                     clearable
                     @change="fetchList(true)"
                     style="width:300px;">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户"
                      prop="name">
          <el-input v-model="query.user_keyword"
                    placeholder="输入用户ID/姓名/手机号"
                    @input="searchSetTimeout()"
                    clearable
                    style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="推广员"
                      prop="name">
          <el-input v-model="query.referrer_keyword"
                    placeholder="输入推广员ID/姓名"
                    @input="searchSetTimeout()"
                    clearable
                    style="width:300px;"></el-input>
        </el-form-item>

        <el-form-item label="下单时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          style="width:300px;"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <p class="title">查找结果</p>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="order_id"
                           width="80"
                           label="订单ID"
                           align="center">
          </el-table-column>
          <el-table-column prop="order_no"
                           width="200"
                           label="订单编号"
                           align="center">
          </el-table-column>
          <el-table-column label="用户信息"
                           width="180"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.user_nickname}}
            </template>
          </el-table-column>

          <el-table-column prop="name"
                           label="商品名称"
                           align="center"
                           show-overflow-tooltip
                           width="240">
            <template slot-scope="scope">
              {{ scope.row.goods_name }}
            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="付款金额"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.pay_amount}}元
            </template>
          </el-table-column>
          <el-table-column label="订单状态"
                           align="center">
            <template slot-scope="scope">
              <span>{{ statusRender(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="返佣金额"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.referrer_amount?scope.row.referrer_amount:0}}元
            </template>
          </el-table-column>
          <el-table-column width="180"
                           label="学长"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.referer_realnames}}/{{scope.row.referer_mobiles}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="修改时间"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="160px"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="openDetail(scope.row)">详情</el-link>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <OrderDialog :id="orderId"
                 :visible="dialogVisible"
                 :content="orderInfo"
                 @close="dialogVisible = false" />
  </div>
</template>

<script>
import OrderDialog from '@/components/dialog/order/OrderDetail'
import { authorOrderlist } from '@/api/senior'

let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    OrderDialog,
  },
  data() {
    return {
      dialogVisible: false,
      orderInfo: {},
      query: {
        order_status: '',
        user: '',
        senior: '',
        startTime: '',
        endTime: '',
        ref_type: '',
        type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      createDatetime: '',
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '已支付', value: 1 },
          { label: '待发货', value: 2 },
          { label: '已发货', value: 3 },
        ],
        types: [
          { label: '全部', value: '' },
          { label: '课程', value: 1 },
          { label: '题库', value: 2 },
          { label: '阅读资料', value: 3 },
          { label: '实体资料', value: 4 },
        ],
      },
      results: [],
      counts: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
      orderId: null,
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  created() {
    this.parseQuery()
    this.fetchOrderList()
  },
  methods: {
    // 学长订单列表请求
    fetchOrderList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      authorOrderlist(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    handleRender(value, type) {
      let productTypes = {
        1: '课程',
        2: '题库',
        3: '阅读',
        4: '实体资料',
      }
      let orderStatus = {
        1: '已支付',
        2: '待发货',
        3: '已发货',
        4: '可提现',
        5: '已提现',
        6: '已退款',
      }
      if (type == 'productType') {
        return productTypes[value] || ''
      } else if (type == 'orderStatus') {
        return orderStatus[value] || ''
      }
      return ''
    },
    handleInfo() {
      this.dialogVisible = true
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchOrderList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchOrderList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchOrderList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchOrderList()
      }, 20)
    },
    statusRender(status) {
      const order_status = {
        0: '待支付',
        1: '已支付',
        2: '待发货',
        3: '待收货',
        4: '已完成',
        5: '已取消',
      }
      return order_status[status] || ''
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchOrderList(true)
      }, TimerTime)
    },
    timechange(e) {
      if (e == null) {
        this.query.startTime = ''
        this.query.endTime = ''
      }
      this.fetchOrderList(true)
    },
    openDetail(row) {
      this.orderId = row.order_id
      this.dialogVisible = true
    },
  },
}
</script>

<style scoped lang="less">
.experience {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 32px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        font-size: 14px;
        padding: 12px 20px;
      }
    }
  }
  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .menu-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
